export const FEASBILITY_MESSAGE: any = {
  FEASIBILITY_ERROR: 'Incorrect Feasibility ID. Please enter correct Feasibility ID.',
  FEASIBILITY_EXPIRED: 'Feasibility ID is expired. Please click on Proceed to raise feasibility again.',
  PRODUCT_MISMATCH: 'Incorrect Feasibility ID. Please enter correct Feasibility ID having the product',
  MAX_BANDWIDTH_ERROR: 'Incorrect Feasibility ID. Running bandwidth is more than maximum feasible bandwidth.'
};

export const feasibility_type = {
  PRODUCT_MISMATCH: 'PRODUCT_MISMATCH',
  FEASIBILITY_EXPIRED: 'FEASIBILITY_EXPIRED',
  FEASIBILITY_ERROR: 'FEASIBILITY_ERROR'
};
